// @flow
import * as React from 'react';
import type ResponseModel from '../../models/Response';
import AuthorInfo from '../ContentSection/AuthorInfo';
import UserGeneratedTextContainer from './UserGeneratedTextContainer';

export default function Response(props: { model: ResponseModel }) {
  const {
    model,
    model: { text, ugctype },
  } = props;

  let title = getTitle(ugctype);

  return (
    <section className="mv3">
      <header className="bt b1 bw1 pt3 b--light-gray ph4">
        <h3 className="ma0 f4">{title}</h3>
        <AuthorInfo ugc={model} />
      </header>
      <p className="mh4 mv0">
        <UserGeneratedTextContainer text={text} />
      </p>
    </section>
  );
}

export function SimpleResponse(props: { ugc: ResponseModel }) {
  const {
    ugc,
    ugc: { text, ugctype },
  } = props;
  const title = getTitle(ugctype);

  return (
    <section>
      <header>
        <h3 className="ma0">{title}</h3>
        <AuthorInfo ugc={ugc} />
      </header>
      <p className="mb0">
        <UserGeneratedTextContainer text={text} />
      </p>
    </section>
  );
}

function getTitle(ugctype: string) {
  if (ugctype === 'MerchantResponse') return 'Merchant Response';
  if (ugctype === 'BrandMerchantResponse') return 'Brand Response';

  return ugctype;
}



// WEBPACK FOOTER //
// ./src/components/ContentSection/ReviewResponse.js